module.exports = __webpack_public_path__ + "img/spotify_white.2ad76a04.png";